import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  offers: {
    flexDirection: "column",
    gap: spacing(4),
  },
  activeOffer: {
    paddingBottom: spacing(6),
    marginBottom: spacing(2),
    borderBottomWidth: border.widths.md,
    borderBottomColor: colors.borderDefault,
  },
  coupon: {
    marginTop: spacing(4),
  },
}));

export default stylesheet;
